<template>
    <div style="width: 1200px; margin:0px auto;  no-repeat; background-size:100%;">

      <div style="background:#fff;">
      <slot name="title">
        <!-- <div class="default-title"></div> -->
      </slot>

      </div>
      <div style="background:#fff;">
      <slot></slot>
      </div>
    </div>
</template>

<script>
export default {
    name: "card",

}
</script>

<style lang="less" scoped>
.default-title{
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/common/card.vue